import { Api } from '../api';
import { dictionaries } from '../endpoints';
import type { CountryEntity } from './models';

export class MiscApi extends Api {
  static getCountries = (signal?: AbortSignal) => this.get<CountryEntity[]>({ url: dictionaries.getCountries(), signal });

  static getNationalities = (signal?: AbortSignal) => this.get<string[]>({ url: dictionaries.getNationalities(), signal });

  static getEconomicActivities = (signal?: AbortSignal) => this.get<string[]>({ url: dictionaries.getEconomicActivities(), signal });
}
